import axiosInstance from "auth/FetchInterceptor";
import {
  BAN_GIAO_TAI_SAN_API,
} from "constants/ApiConstant";

const BanGiaoTaiSanService = {};

BanGiaoTaiSanService.GetAll = function (data) {
  return axiosInstance.post(`${BAN_GIAO_TAI_SAN_API}/search`, data,{
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.CreateUpdate = function (data) {
  return axiosInstance.post(`${BAN_GIAO_TAI_SAN_API}`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.GetThongTinPhieu = function (id) {
  return axiosInstance.get(`${BAN_GIAO_TAI_SAN_API}?id=${id}`,  {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.DanhSachTaiSanBanGiao = function (id) {
  return axiosInstance.get(`${BAN_GIAO_TAI_SAN_API}/chitiet?banGiaoId=${id}`,  {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.DeletePhieu = function (id) {
  return axiosInstance.delete(`${BAN_GIAO_TAI_SAN_API}?id=${id}`,  {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.CreateUpdateChiTiet = function (data) {
  return axiosInstance.post(`${BAN_GIAO_TAI_SAN_API}/chitiet`, data, {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.DeleteChiTiet = function (id) {
  return axiosInstance.delete(`${BAN_GIAO_TAI_SAN_API}/chitiet?id=${id}`,  {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};

BanGiaoTaiSanService.GetTaiSanChuaBanGiaoSauSuaChua = function (data) {
  return axiosInstance.post(`${BAN_GIAO_TAI_SAN_API}/cothebangiao`,data,  {
    baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
  });
};






export default BanGiaoTaiSanService;
